import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'form-session-location',
  templateUrl: './form-session-location.component.html',
  styleUrls: ['./form-session-location.component.scss']
})
export class FormSessionLocationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
